import {atom} from "jotai";
export const visibleModalDocumentoAtom = atom(false);
export const documentosListadosAtom = atom([]);
export const documentosSeleccionadosAtom = atom ([]);
export const plantillaEnvioDocumentosAtom = atom();


